import { useGlobalLoader } from "./base/utils/globalRefreshLoader";
import { setupInterceptor } from "./base/utils/http";
import { store } from "./store";

const InterceptorProvider = ({children}) => {
   const { setGlobalLoader } = useGlobalLoader();

   // Called during render, not in useEffect: React runs child effects before parent
   // effects, so pages that fetch on mount (e.g. /organization-profile) would send
   // their first requests before the interceptors exist - without an Authorization
   // header - and get 401s. setupInterceptor only registers the interceptors once.
   setupInterceptor(store, setGlobalLoader);

   return children;
}

export default InterceptorProvider;
